import React from "react";
import { Facebook, Twitter, Linkedin, Instagram, MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const pages = [{
    title: "Home",
    path: "/HomePage"
  }, {
    title: "Clinical Leadership",
    path: "/ClinicalLeadershipPage"
  }, {
    title: "Precision Care",
    path: "/PrecisionCarePage"
  }, {
    title: "Resources",
    path: "/ResourcesPage"
  }, {
    title: "Contact",
    path: "https://sharmatpsychiatricgroup.com/contact/"
  }];
  const socials = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <section id="footer" className="bg-primary text-primary-foreground py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <img src="https://samuelsharmatmd.com/wp-content/uploads/2026/02/SPG-header-PNG.png" alt="Sharmat Psychiatric Group" className="h-7 w-auto object-contain" />
            </Link>
            <div className="space-y-4">
              <div className="space-y-1">
                <h3 className="font-serif text-lg font-medium tracking-wide">Clinical Leadership</h3>
                <p className="text-sm text-primary-foreground/80 leading-relaxed">
                  <span className="font-semibold text-primary-foreground">Dr. Samuel L. Sharmat</span>
                  <br />
                  Lead Psychiatrist
                </p>
                <p className="text-sm text-primary-foreground/80 leading-relaxed">
                  <span className="font-semibold text-primary-foreground">Maryellen Stephens</span>
                  <br />
                  Board-certified Nurse Practitioner
                </p>
              </div>
              <p className="text-sm text-primary-foreground/70 italic">
                Combining advanced genetic insights with compassionate care.
              </p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium tracking-wide">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              {pages.map((page, i) => <div key={i} data-index={i}>
                  <Link to={page.path} className="text-sm text-primary-foreground/80 hover:text-accent transition-colors w-fit inline-block">
                    {page.title}
                  </Link>
                </div>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium tracking-wide">Contact</h3>
            <div className="flex flex-col gap-4 text-sm text-primary-foreground/80">
              <div className="flex items-start gap-3">
                <MapPin className="size-4 mt-1 shrink-0 text-accent" />
                <span>315 5th Ave Rm 701, New York City, NY 10016</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-accent" />
                <Link to="tel:+12128047665" className="hover:text-accent transition-colors">
                  (212) 804-7665
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="size-4 mt-1 shrink-0 text-accent" />
                <span>
                  Mon–Tue: 11am–7pm
                  <br />
                  Wed-Thu: 8:30am-4:30pm
                  <br />
                  Fri: 8:30am-1:30pm
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium tracking-wide">Important Notice</h3>
            <div className="space-y-4 text-[12px] leading-relaxed text-primary-foreground/60">
              <p>
                <strong className="text-destructive-foreground font-bold uppercase tracking-wider">Emergency:</strong> If you are experiencing a medical emergency or a mental health crisis, please dial 911 immediately or visit your nearest emergency room.
              </p>
              <p>
                The content on this website is for informational purposes only and does not constitute medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.
              </p>
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-primary-foreground/10" />

        <div>
          <p className="text-xs text-primary-foreground/50 text-center md:text-center">
            &copy; {currentYear} Sharmat Psychiatric Group. All rights reserved.
          </p>


        </div>
      </div>
    </section>;
}